"use client"

import { Button } from "@/components/ui/button"
import { Checkbox } from "@/components/ui/checkbox"
import { ColumnDef } from "@tanstack/react-table"

import { ArrowUpDown } from "lucide-react"
import Actions from "./Actions"
import { DataTagihanUktPlaza, DataUktPendaftarLulus } from "@/types"
import { formatRupiah } from "@/lib/utils"
import { Badge } from "@/components/ui/badge"

export const columns: ColumnDef<DataUktPendaftarLulus>[] = [
  {
    id: "select",
    header: ({ table }) => (
      <Checkbox
        checked={
          table.getIsAllPageRowsSelected() ||
          (table.getIsSomePageRowsSelected() && "indeterminate")
        }
        onCheckedChange={(value) => table.toggleAllPageRowsSelected(!!value)}
        aria-label="Select all"
      />
    ),
    cell: ({ row }) => (
      <Checkbox
        checked={row.getIsSelected()}
        onCheckedChange={(value) => row.toggleSelected(!!value)}
        aria-label="Select row"
      />
    ),
    enableSorting: false,
    enableHiding: false,
  },
  {
    accessorKey: "data_pendaftaran.periode.tahun",
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          Tahun
          <ArrowUpDown className="w-4 h-4 ml-2" />
        </Button>
      )
    },
  },
  {
    accessorKey: "data_pendaftaran.periode.jalur_jenis.nama_jalur_jenis",
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          Jalur
          <ArrowUpDown className="w-4 h-4 ml-2" />
        </Button>
      )
    },
  },
  {
    accessorKey: "data_pendaftaran.nomor_pendaftaran",
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          Nomor Pendaftaran
          <ArrowUpDown className="w-4 h-4 ml-2" />
        </Button>
      )
    },
  },
  {
    accessorKey: "data_pendaftaran.data_siswa.nama_lengkap",
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          Nama Lengkap
          <ArrowUpDown className="w-4 h-4 ml-2" />
        </Button>
      )
    },
  },
  {
    accessorKey: "is_konfirmasi_kipk",
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          Status Konfirmasi KIPK
          <ArrowUpDown className="w-4 h-4 ml-2" />
        </Button>
      )
    },
    cell: ({ row }) => {
      return row.original?.is_konfirmasi_kipk == 1 ? (
        <Badge variant={"default"}>Sudah Konfirmasi</Badge>
      ) : row.original?.kode_jenis_ukt == "32" ? (
        <Badge variant={"secondary"}>Belum Konfirmasi</Badge>
      ) : (
        ""
      )
    },
  },
  {
    accessorKey: "data_pendaftaran.data_pilihan_prodi.unitkerja.nama",
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          Prodi
          <ArrowUpDown className="w-4 h-4 ml-2" />
        </Button>
      )
    },
    cell: ({ row }) => {
      return (
        <div>
          {row.original.data_pendaftaran?.data_pilihan_prodi &&
            row.original.data_pendaftaran?.data_pilihan_prodi[0].unitkerja
              ?.nama}
        </div>
      )
    },
  },
  {
    accessorKey: "ref_nominal_ukt.jenis_ukt.nama_jenis_ukt",
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          Jenis UKT
          <ArrowUpDown className="w-4 h-4 ml-2" />
        </Button>
      )
    },
  },
  {
    accessorKey: "nominal_ukt",
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          Nominal UKT
          <ArrowUpDown className="w-4 h-4 ml-2" />
        </Button>
      )
    },
    cell: ({ row }) => {
      return <div>{formatRupiah(row.getValue("nominal_ukt"))}</div>
    },
  },
  {
    accessorKey: "nominal_ipi",
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          Nominal IPI
          <ArrowUpDown className="w-4 h-4 ml-2" />
        </Button>
      )
    },
    cell: ({ row }) => {
      return <div>{formatRupiah(row.getValue("nominal_ipi"))}</div>
    },
  },
  {
    accessorKey: "total_tagihan",
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          Total Tagihan
          <ArrowUpDown className="w-4 h-4 ml-2" />
        </Button>
      )
    },
    cell: ({ row }) => {
      return <div>{formatRupiah(row.getValue("total_tagihan"))}</div>
    },
  },
  {
    accessorKey: "data_tagihan_ukt_plaza",
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          Data Tagihan
          <ArrowUpDown className="w-4 h-4 ml-2" />
        </Button>
      )
    },
    cell: ({ row }) => {
      return (
        <div>
          {row.original?.data_tagihan_ukt_plaza &&
          row.original?.data_tagihan_ukt_plaza?.length > 0
            ? row.original.data_tagihan_ukt_plaza?.map(
                (tagihan: DataTagihanUktPlaza) => {
                  return (
                    <div>
                      <p>{tagihan?.nomor_tagihan}</p>
                      <div>
                        {tagihan.status_bayar == 1 ? (
                          <Badge variant={"secondary"}>Belum dibayar</Badge>
                        ) : tagihan.status_bayar == 2 ? (
                          <Badge variant={"success"}>Sudah dibayar</Badge>
                        ) : tagihan.status_bayar == 3 ? (
                          <Badge variant={"destructive"}>Expired</Badge>
                        ) : tagihan.status_bayar == 4 ? (
                          <Badge variant={"success"}>Sudah Bayar Tunda</Badge>
                        ) : tagihan.status_bayar == 5 ? (
                          <Badge variant={"success"}>Beasiswa</Badge>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  )
                }
              )
            : ""}
        </div>
      )
    },
  },
  {
    accessorKey: "is_titipan",
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          Titipan
          <ArrowUpDown className="w-4 h-4 ml-2" />
        </Button>
      )
    },
    cell: ({ row }) => {
      return row.original?.is_titipan ? (
        <Badge variant={"default"}>Titipan</Badge>
      ) : (
        ""
      )
    },
  },
  {
    accessorKey: "is_show_genrate_surat_pernyataan",
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          Show Generate SP
          <ArrowUpDown className="w-4 h-4 ml-2" />
        </Button>
      )
    },
    cell: ({ row }) => {
      return row.original?.is_show_genrate_surat_pernyataan ? (
        <Badge variant={"default"}>SHOW</Badge>
      ) : (
        ""
      )
    },
  },
  {
    id: "actions",
    cell: ({ row }) => {
      return <Actions row={row.original} />
    },
  },
]
